import { Container, Row, Col } from '@paypalcorp/pp-react'
import { VideoRow } from '../../../components/video-lib/sections/VideoRow'
import { navigate } from 'gatsby'
import CircularIconsRow from '../../../components/video-lib/sections/CircularIconsRow'
import '../../../components/video-lib/css/index.css'
import { groupBy } from 'lodash'
import React, { useMemo } from 'react'
import VideoLayout from '../../../components/video-lib/components/VideoLayout'
import videos from '../../../components/video-lib/data/videos.json'
import useParams from '../../../hooks/useParams'
import { VIDEO_BASE_PATH } from '../../../components/video-lib/constants'

function Home() {
  const { q: searchText } = useParams()

  // Function to handle both array and string IDs
  const expandVideoProductIds = (item) => {
    const ids = Array.isArray(item['video-Product-id'])
      ? item['video-Product-id']
      : [item['video-Product-id'] || 'others']
    return ids.map((id) => ({
      ...item,
      'video-Product-id': id.toLowerCase().replace(/\s+/g, ''),
    }))
  }
  const expandedVideos = videos.flatMap(expandVideoProductIds)
  const groupedByProductId = useMemo(
    () => groupBy(expandedVideos, 'video-Product-id'),
    [expandedVideos],
  )

  return (
    <>
      <Container>
        <Row style={{ padding: '2.5rem 0' }}>
          <Col>
            <h1 className="homepageTitle" data-testid="header-title">
              Video Library
            </h1>
          </Col>
          <Col
            className="video-search"
            style={{
              display: 'flex',
              justifyContent: 'end',
              paddingRight: '5rem',
            }}
          >
            <input
              data-testid="search-input"
              value={searchText}
              className="search"
              placeholder="Search by keyword"
              name="search"
              onKeyDown={(e: any) => {
                if (e.key === 'Enter') {
                  navigate(
                    `${VIDEO_BASE_PATH}/collection?q=${e.currentTarget.value}`,
                  )
                }
              }}
            />
          </Col>
        </Row>
      </Container>
      {groupedByProductId.fastlane && (
        <VideoRow
          videosCount={
            groupedByProductId.fastlane && groupedByProductId.fastlane?.length
          }
          videos={
            groupedByProductId.fastlane
              ? groupedByProductId.fastlane.slice(0, 4)
              : []
          }
          title="Fastlane Developer Days"
          viewAllUrl={`${VIDEO_BASE_PATH}/collection?filter=fastlane`}
          altBackground
          dataTestid="fastlane"
        />
      )}
      {groupedByProductId.fastlane && (
        <VideoRow
          videosCount={
            groupedByProductId.fastlane && groupedByProductId.fastlane?.length
          }
          videos={
            groupedByProductId.fastlane
              ? groupedByProductId.fastlane.slice(7, 11)
              : []
          }
          title="How to Integrate Fastlane by PayPal"
          viewAllUrl={`${VIDEO_BASE_PATH}/collection?filter=fastlane`}
          altBackground
          dataTestid="fastlane"
        />
      )}
      <CircularIconsRow
        groupedVideos={groupedByProductId}
        title="Integrate with your ecommerce platform"
      />
      {groupedByProductId['paypal-basics'] && (
        <VideoRow
          videosCount={
            groupedByProductId['paypal-basics'] &&
            groupedByProductId['paypal-basics']?.length
          }
          videos={
            groupedByProductId['paypal-basics']
              ? groupedByProductId['paypal-basics'].slice(0, 4)
              : []
          }
          title="PayPal Basics"
          viewAllUrl={`${VIDEO_BASE_PATH}/collection?filter=paypal-basics`}
          dataTestid="paypal-basics"
        />
      )}

      {groupedByProductId['paypal-checkout'] && (
        <VideoRow
          videosCount={
            groupedByProductId['paypal-checkout'] &&
            groupedByProductId['paypal-checkout']?.length
          }
          videos={
            groupedByProductId['paypal-checkout']
              ? groupedByProductId['paypal-checkout'].slice(0, 4)
              : []
          }
          title="PayPal Checkout"
          viewAllUrl={`${VIDEO_BASE_PATH}/collection?filter=paypal-checkout`}
          dataTestid="paypal-checkout"
        />
      )}

      {groupedByProductId['paypal-subscriptions'] && (
        <VideoRow
          videosCount={
            groupedByProductId['paypal-subscriptions'] &&
            groupedByProductId['paypal-subscriptions']?.length
          }
          videos={
            groupedByProductId['paypal-subscriptions']
              ? groupedByProductId['paypal-subscriptions'].slice(0, 4)
              : []
          }
          title="Subscriptions"
          viewAllUrl={`${VIDEO_BASE_PATH}/collection?filter=paypal-subscriptions`}
          dataTestid="paypal-subscriptions"
        />
      )}
    </>
  )
}

export default function HomeWrapper() {
  return (
    <VideoLayout>
      <Home />
    </VideoLayout>
  )
}
